import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

import RenderLoader from "../../../components/RenderLoader";
import SidePanel from "../../../components/SidePanel";
import {
  useCollaboratorQuery,
  useMemberClientQuery
} from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import Content, { NECSummaryDataType } from "./Content";
import { MemberIdUrlKey } from "../../../constants/routing";

export const NEC_1099_SUMMARY_SLUG = "tax-form-draft";

const handlers = {
  [NECSummaryDataType.Client]: {
    paramName: MemberIdUrlKey.Client,
    useQuery: useMemberClientQuery
  },
  [NECSummaryDataType.Collaborator]: {
    paramName: MemberIdUrlKey.Collaborator,
    useQuery: useCollaboratorQuery
  }
};

const NEC1099FilingDetailsSummary: React.FC<{ type: NECSummaryDataType }> = ({
  type
}) => {
  const match = useRouteMatch<{ [key in MemberIdUrlKey]: string }>();
  const history = useHistory();
  const { useQuery, paramName } = handlers[type];
  const query = useQuery(match.params[paramName]);

  return (
    <WSQueries queries={{ query }} renderLoader={RenderLoader}>
      {({ query: { data } }) => (
        <SidePanel
          title="Review 1099-NEC draft summary"
          onClose={history.goBack}
        >
          <Content type={type} data={data} />
        </SidePanel>
      )}
    </WSQueries>
  );
};

export default NEC1099FilingDetailsSummary;
